import React from 'react'
import AllInclusiveIcon from '@mui/icons-material/AllInclusive'
import {
  Box,
  Box as MuiBox,
  CircularProgress as MuiCircularProgress,
  Typography
} from '@mui/material'
import PropTypes from 'prop-types'

export default function CircularProgress(props) {
  const { color, quantity, unit, value, fieldApplicable } = props

  const normalView = (
    <Box display='flex' flexDirection='column'>
      <Box
        display='flex'
        flexDirection='row'
        justifyContent='center'
        alignItems='baseline'
      >
        <Typography variant='h3' style={{ margin: '0px 4px' }}>
          {quantity}
        </Typography>
        <Typography variant='h4' style={{ margin: '0px 4px' }}>
          {unit}
        </Typography>
      </Box>
      <Box display='flex' flexDirection='row' justifyContent='center'>
        <Typography style={{ margin: '4px' }}>Remaining</Typography>
      </Box>
    </Box>
  )

  const unlimitedView = (
    <Box display='flex' flexDirection='column'>
      <Box
        display='flex'
        flexDirection='row'
        justifyContent='center'
        alignItems='baseline'
      >
        <AllInclusiveIcon sx={{ fontSize: 40 }} />
      </Box>
      <Box display='flex' flexDirection='row' justifyContent='center'>
        <Typography style={{ margin: '4px' }}>Unlimited</Typography>
      </Box>
    </Box>
  )

  const notApplicableView = (
    <Box display='flex' flexDirection='column'>
      <Box
        display='flex'
        flexDirection='row'
        justifyContent='center'
        alignItems='baseline'
      >
        <strong style={{ fontSize: 40 }}> - </strong>
      </Box>
    </Box>
  )

  return (
    <MuiBox sx={{ position: 'relative', display: 'inline-flex' }}>
      <MuiCircularProgress
        variant='determinate'
        value={value !== 0 ? value : 100}
        thickness={3}
        style={{ width: '256px', height: '256px', color }}
      />
      <MuiBox
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {!fieldApplicable
          ? notApplicableView
          : quantity !== 0
          ? normalView
          : unlimitedView}
      </MuiBox>
    </MuiBox>
  )
}

CircularProgress.propTypes = {
  color: PropTypes.string,
  quantity: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  fieldApplicable: PropTypes.bool
}
